import React from 'react'
import { SvgIcon } from '../svg-icon'

const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a trending icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example <TrendingIcon width={12}/>
 */

const TrendingIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M24.073,2.043c-12.138,0-21.979,9.84-21.979,21.978S11.935,46,24.073,46s21.978-9.84,21.978-21.979
		          S36.212,2.043,24.073,2.043z M29.778,38.36c-0.741,0.885-1.804,1.341-2.874,1.341c-0.849,
		          0-1.701-0.287-2.403-0.873c-1.587-1.328-1.796-3.691-0.468-5.278l4.841-5.783H10.43c-2.069,
		          0-3.746-1.677-3.746-3.746s1.677-3.746,3.746-3.746h18.443l-4.84-5.782c-1.328-1.587-1.119-3.949,
		          0.468-5.277c1.586-1.329,3.949-1.12,5.277,0.467l9.99,11.933c1.165,1.391,1.165,3.418,0,4.81L29.778,
		          38.36z`}
        />
    </SvgIcon>
)

TrendingIcon.defaultProps = defaultProps

export { TrendingIcon }
